import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/jobform/new')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/settings/appointment-forms/new',
      search: { surface: 'VISIT_FORM' },
      replace: true,
    });
  },
  component: () => null,
});
